import { Box, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import QRCode from "react-qr-code";

const SubscriptionPageContent = () => {
  return (
    <Box sx={{ width: "75%", margin: "auto" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "60%",
          margin: "0 auto",
          marginTop: "3%",
          height: "auto",
          padding: "2%",
          gap: 4,
          background: "rgba(255, 255, 255, 0.06)",
          borderRadius: "15px",
          boxShadow: "inset 0 0 0 1px #3b2323",
        }}
      >
        <Typography
          sx={{
            fontSize: "32px",
            fontWeight: 700,
            lineHeight: "62.76px",
            textAlign: "center",
            color: "#F0F0F0",
            marginBottom: "5%",
          }}
        >
          خرید اشتراک
        </Typography>
        <Box
          sx={{ display: "flex", justifyContent: "space-between" }}
          className="mb-5"
        >
          <Box>
            <Typography
              sx={{
                fontSize: "28px",
                fontWeight: 700,
                lineHeight: "56.81px",
                textAlign: "right",
                color: "#BFBFBF",
                marginTop: "15%",
              }}
            >
              روش اول
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                lineHeight: "56.81px",
                textAlign: "right",
                color: "#D9D9D9",
              }}
            >
              کد روبرو را اسکن کنید
            </Typography>
            <Typography
              sx={{
                fontSize: "24px",
                lineHeight: "56.81px",
                textAlign: "right",
                color: "#D9D9D9",
              }}
            >
              وارد صفحه خرید اشتراک میشوید
            </Typography>
          </Box>
          <Box
            sx={{
              background: "#121212",
              minWidth: "215px",
              height: "auto",
              borderRadius: "24px",
              border: "1px solid #BFBFBF",
            }}
          >
            <QRCode
              size={256}
              style={{
                height: "215px",
                maxWidth: "215px",
                width: "100%",
                padding: "15px",
              }}
              value={"https://manabakh.ir/subscription"}
              viewBox={`0 0 256 256`}
              bgColor="#BFBFBF"
              fgColor="#121212"
            />
          </Box>
        </Box>
        <Typography
          sx={{
            fontSize: "28px",
            fontWeight: 700,
            lineHeight: "56.81px",
            textAlign: "right",
            color: "#BFBFBF",
          }}
        >
          روش دوم
        </Typography>
        <Typography
          sx={{
            fontSize: "24px",
            lineHeight: "56.81px",
            textAlign: "right",
            color: "#D9D9D9",
          }}
        >
          با مراجعه به لینک زیر از طریق مرورگر رایانه یا گوشی موبایل خود؛ وارد
          صفحه خرید اشتراک میشوید.
        </Typography>
        <Link
          href="https://www.manabakh.ir/subscription"
          className="mt-5"
          target="_blank"
        >
          <Button
            variant="contained"
            sx={{
              width: "100%",
              color: "#D9D9D9",
              background: "#121212",
              padding: "2.5% 0",
              "&:hover": {
                background: "rgb(30,11,11)",
              },
              borderRadius: "24px",
              fontSize: "26px",
            }}
          >
            www.manabakh.ir/subscription
          </Button>
        </Link>
      </Box>
    </Box>
  );
};
export default SubscriptionPageContent;
